import {Component, OnInit} from '@angular/core';
import {ModalKendo} from "../../lib/ModalKendo";
import {FiadosService} from "../../services/fiados.service";
import {FiadoFormaPagamentoUtils} from "../fiado-forma-pagamento.utils";

@Component({
  selector: 'app-modal-acerto-fiado',
  templateUrl: './modal-acerto-fiado.component.html',
  styleUrls: ['./modal-acerto-fiado.component.scss']
})
export class ModalAcertoFiadoComponent extends ModalKendo implements OnInit {
  contato: any;
  lancamentos: any[] = [];
  private _formasDePagamento: any[] = [];
  get formasDePagamento() {
    return this._formasDePagamento;
  }
  set formasDePagamento(formas: any[]) {
    this._formasDePagamento = (formas || [])
      .filter((forma: any) => this.formaPermitida(forma));
    this.garantaFormaDePagamentoSelecionada();
  }
  carregando = false;
  exibindoPedidos = false;
  escolhendoOutraFormaPagamento = false;
  erro = '';
  dados: any = {
    idContato: null,
    idFormaDePagamento: null,
    observacao: '',
    itens: [],
    valorSaldoUtilizado: 0,
    valorPagamento: 0
  };

  constructor(private fiadosService: FiadosService) {
    super();
  }

  ngOnInit(): void {
    this.dados.idContato = this.contato?.id;
    this.lancamentos = (this.lancamentos || [])
      .filter((item: any) => this.obtenhaIdContatoLancamento(item) === Number(this.dados.idContato || 0)
        && this.lancamentoEmAberto(item));
    this.dados.itens = this.lancamentos.map((item: any) => ({
      id: item.id,
      idFiadoCaderno: item.id,
      selecionado: true,
      valorPago: item.saldo
    }));

    this.apliqueSaldoDisponivel();
    this.garantaFormaDePagamentoSelecionada();
  }

  private garantaFormaDePagamentoSelecionada() {
    const formaSelecionadaPermitida = this._formasDePagamento
      .some((forma: any) => forma.id === this.dados.idFormaDePagamento);

    if(!formaSelecionadaPermitida)
      this.dados.idFormaDePagamento = this._formasDePagamento.length ? this._formasDePagamento[0].id : null;
  }

  itemSelecionado(idFiado: number) {
    return this.dados.itens.find((item: any) => item.idFiadoCaderno === idFiado);
  }

  formaPermitida(forma: any) {
    return FiadoFormaPagamentoUtils.formaPermitidaParaRecebimento(forma);
  }

  obtenhaTotalSelecionado() {
    return (this.dados.itens || [])
      .filter((item: any) => item.selecionado && Number(item.valorPago) > 0)
      .reduce((total: number, item: any) => total + Number(item.valorPago), 0);
  }

  obtenhaSaldoDisponivel() {
    return Math.max(0, Number(this.contato?.contaFinanceira?.saldo || 0));
  }

  obtenhaValorSaldoMaximo() {
    return Math.min(this.obtenhaSaldoDisponivel(), this.obtenhaTotalSelecionado());
  }

  apliqueSaldoDisponivel() {
    this.escolhendoOutraFormaPagamento = false;
    this.dados.valorSaldoUtilizado = this.obtenhaValorSaldoMaximo();
    this.atualizeValorPagamentoSugerido();
  }

  alterneUsoSaldo() {
    this.dados.valorSaldoUtilizado = this.obtenhaValorSaldoInformado() > 0 ? 0 : this.obtenhaValorSaldoMaximo();
    this.escolhendoOutraFormaPagamento = this.obtenhaValorSaldoInformado() === 0;
    this.atualizeValorPagamentoSugerido();
  }

  pagueComOutraForma() {
    this.escolhendoOutraFormaPagamento = true;
    this.dados.valorSaldoUtilizado = 0;
    this.atualizeValorPagamentoSugerido();
  }

  atualizeValorPagamentoSugerido() {
    const valorSaldo = this.obtenhaValorSaldoInformado();
    const valorSaldoMaximo = this.obtenhaValorSaldoMaximo();

    if(valorSaldo > valorSaldoMaximo)
      this.dados.valorSaldoUtilizado = valorSaldoMaximo;
    else if(valorSaldo < 0)
      this.dados.valorSaldoUtilizado = 0;

    this.dados.valorPagamento = this.obtenhaValorPagamentoSugerido();
  }

  obtenhaValorPagamentoInformado() {
    return Number(this.dados.valorPagamento || 0);
  }

  obtenhaValorSaldoInformado() {
    return Number(this.dados.valorSaldoUtilizado || 0);
  }

  obtenhaValorPagamentoSugerido() {
    return Math.max(0, Number((this.obtenhaTotalSelecionado() - this.obtenhaValorSaldoInformado()).toFixed(2)));
  }

  obtenhaValorExcedente() {
    return Math.max(0, Number((this.obtenhaValorSaldoInformado() + this.obtenhaValorPagamentoInformado()
      - this.obtenhaTotalSelecionado()).toFixed(2)));
  }

  obtenhaValorFaltante() {
    return Math.max(0, Number((this.obtenhaTotalSelecionado() - this.obtenhaValorSaldoInformado()
      - this.obtenhaValorPagamentoInformado()).toFixed(2)));
  }

  obtenhaQuantidadeSelecionada() {
    return (this.dados.itens || []).filter((item: any) => item.selecionado && Number(item.valorPago) > 0).length;
  }

  deveExibirFormasPagamento() {
    return this.obtenhaValorPagamentoSugerido() > 0 || this.escolhendoOutraFormaPagamento;
  }

  deveExibirPagamentoAgora() {
    return this.deveExibirFormasPagamento();
  }

  deveExibirBlocoSaldo() {
    return this.obtenhaSaldoDisponivel() > 0
      && (this.obtenhaValorSaldoInformado() > 0 || this.escolhendoOutraFormaPagamento);
  }

  pagoIntegralmenteComSaldo() {
    return this.obtenhaTotalSelecionado() > 0
      && this.obtenhaValorSaldoInformado() >= this.obtenhaTotalSelecionado()
      && this.obtenhaValorPagamentoSugerido() === 0;
  }

  obtenhaSaldoRestanteAposAcerto() {
    return Math.max(0, Number((this.obtenhaSaldoDisponivel() - this.obtenhaValorSaldoInformado()).toFixed(2)));
  }

  abraPedidos() {
    this.exibindoPedidos = true;
  }

  fechePedidos() {
    this.exibindoPedidos = false;
    this.atualizeValorPagamentoSugerido();
  }

  selecioneFormaDePagamento(forma: any) {
    this.escolhendoOutraFormaPagamento = true;
    this.dados.idFormaDePagamento = forma?.id || null;
  }

  formaSelecionada(forma: any) {
    return !!forma && this.dados.idFormaDePagamento === forma.id;
  }

  obtenhaTituloFormaPagamento(forma: any) {
    return forma?.descricao ||  forma?.nome ;
  }

  obtenhaFormaPagamentoSelecionada() {
    return (this.formasDePagamento || []).find((forma: any) => this.formaSelecionada(forma));
  }

  obtenhaTituloFormaPagamentoSelecionada() {
    return this.obtenhaTituloFormaPagamento(this.obtenhaFormaPagamentoSelecionada());
  }

  obtenhaTotalPagoAgora() {
    return Number((this.obtenhaValorSaldoInformado() + this.obtenhaValorPagamentoInformado()).toFixed(2));
  }

  obtenhaDescricaoFormaPagamento(forma: any) {
    const nome = String(forma?.nome || forma?.descricao || '').toLowerCase();

    if(nome.includes('pix') && nome.includes('chave')) return 'Pagamento via chave PIX';
    if(nome.includes('pix')) return 'Pagamento instantaneo';
    if(nome.includes('dinheiro')) return 'Pagamento em especie';
    if(nome.includes('credito')) return 'Credito a vista ou parcelado';
    if(nome.includes('debito')) return 'Debito a vista';
    if(nome.includes('vale') || nome.includes('voucher')) return 'Vale, troco ou outro meio';

    return forma?.nome || 'Pagamento offline';
  }

  obtenhaIconeFormaPagamento(forma: any) {
    const nome = String(forma?.nome || forma?.descricao || '').toLowerCase();

    if(nome.includes('pix') && nome.includes('chave')) return 'fa-key';
    if(nome.includes('pix')) return 'fa-qrcode';
    if(nome.includes('dinheiro')) return 'fa-money-bill-wave';
    if(nome.includes('credito') || nome.includes('debito')) return 'fa-credit-card';
    if(nome.includes('vale') || nome.includes('voucher')) return 'fa-ticket-alt';

    return 'fa-wallet';
  }

  obtenhaCorFormaPagamento(forma: any) {
    const nome = String(forma?.nome || forma?.descricao || '').toLowerCase();

    if(nome.includes('pix') && nome.includes('chave')) return 'teal';
    if(nome.includes('pix')) return 'purple';
    if(nome.includes('dinheiro')) return 'green';
    if(nome.includes('credito')) return 'violet';
    if(nome.includes('debito')) return 'blue';
    if(nome.includes('vale') || nome.includes('voucher')) return 'orange';

    return 'gray';
  }

  private obtenhaIdContatoLancamento(lancamento: any) {
    return Number(lancamento?.contato?.id || lancamento?.pedido?.contato?.id || lancamento?.pedido?.cliente?.id || 0);
  }

  private lancamentoEmAberto(lancamento: any) {
    const status = String(lancamento?.status || '').toLowerCase();
    return (status === 'aberto' || status === 'parcial') && Number(lancamento?.saldo || 0) > 0;
  }

  onSubmit() {
    this.erro = '';

    const itens = this.dados.itens
      .filter((item: any) => item.selecionado && Number(item.valorPago) > 0)
      .map((item: any) => ({
        idFiadoCaderno: item.idFiadoCaderno,
        valorPago: Number(item.valorPago)
      }));

    if(!itens.length) {
      this.erro = 'Selecione ao menos um lançamento para quitar.';
      return;
    }

    if(this.obtenhaValorSaldoInformado() > this.obtenhaSaldoDisponivel()) {
      this.erro = 'O valor informado para usar do saldo é maior que o saldo disponível.';
      return;
    }

    if(this.obtenhaValorFaltante() > 0) {
      this.erro = 'O valor informado entre saldo e pagamento não cobre o total do acerto.';
      return;
    }

    if(this.obtenhaValorPagamentoInformado() > 0 && !this.dados.idFormaDePagamento) {
      this.erro = 'Selecione a forma de pagamento do acerto.';
      return;
    }

    const valorExcedente = this.obtenhaValorExcedente();
    if(valorExcedente > 0) {
      const confirmado = window.confirm(
        `O valor excedente de ${valorExcedente.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})} será convertido em crédito para o cliente. Deseja continuar?`
      );
      if(!confirmado) return;
    }

    this.carregando = true;

    this.fiadosService.quiteLancamentos({
      idContato: this.dados.idContato,
      idFormaDePagamento: this.dados.idFormaDePagamento,
      observacao: this.dados.observacao,
      itens: itens,
      valorSaldoUtilizado: this.obtenhaValorSaldoInformado(),
      valorPagamento: this.obtenhaValorPagamentoInformado(),
      confirmarCreditoExcedente: valorExcedente > 0
    }).then((resposta: any) => {
      this.carregando = false;
      this.fecheModal(resposta);
    }).catch((erro: any) => {
      this.carregando = false;
      this.erro = erro;
    });
  }
}
